var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"configurator"},[(_vm.$screen.desktop)?_c('router-view',{attrs:{"name":"desktopview"}}):_vm._e(),_c('div',{staticClass:"sidebar"},[_c('router-view',{attrs:{"name":"sidebar"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }